import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-menu',
  templateUrl: './grid-menu.component.html',
  styleUrls: ['./grid-menu.component.scss'],
})
export class GridMenuComponent implements OnInit {
  @Input() menuList: any[];
  @Input() helpList: any[] = [];

  constructor() {}

  ngOnInit() {}

  getMenuTitle(menuEntry: any): string {
    if (menuEntry.title) {
      return menuEntry.title;
    }

    let title = menuEntry.icon;

    this.helpList.find((row) => {
      if (menuEntry.icon === row.icon) {
        title = row.title;
        return;
      }
    });

    return title;
  }

  onClick(menu: any) {
    if (menu.condition) {
      if (menu.condition()) {
        menu.action();
      }
    } else {
      menu.action();
    }
  }
}
